<template>
    <div class="all-order">
        <div class="all-order-content">

            <template v-if="list && list.length">
                <el-table :data="list" style="width: 100%" row-key="id" :stripe="true" show-summary  :summary-method="getSummaries"  border
                :tree-props="{ children: 'childrens', hasChildren: 'hasChildren' }"
                :header-cell-style="{ background: '#fafafa', color: '#333' }">
                <!-- <el-table-column type="index" label="编号" align="center"  width="120"/> -->
                <el-table-column prop="displayOrder" label="编号" align="center" />
                <el-table-column prop="name" label="项目" align="center" />
                <el-table-column prop="specs" label="规格" align="center" />
                <el-table-column prop="unit" label="单位" align="center" />
                <el-table-column prop="price" label="单价" align="center" />
                <el-table-column prop="number" label="数量" align="center">
                    <!-- <template slot-scope="scope">
                        <el-input v-model.number='scope.row.number' type='number' size="small" maxlength='200'
                            placeholder="请输入" @input="validScore(scope.row)" />
                    </template> -->
                </el-table-column>
                <el-table-column prop="total" label="金额" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.total }}元
                    </template>
                </el-table-column>
            </el-table>
            </template>

            <div class="" v-else>
                <el-empty description="展商还未提交此内容">
                    <p>截止时间为：{{ timeValue }}，可提醒展商及时提交信息</p>
                </el-empty>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    name: "all-order",
    props:{
        timeValue:String
    },
    data () {
        return {
            list: [],

       
        }
    },
    computed: {
        ...mapGetters({
            formHeaders: "getFormHeaders",
            uploadUrl: "getUploadUrl",
            joinInfo: "loginModule/getJoinInfo",
            company: "loginModule/getCompany",
            exhibition: "loginModule/getExhibition",

            exhibitor: "loginModule/getExhibitor",
        }),
        queryId () {
            return this.$route.query.id;
        },
        
    },
    created () {
         
        // this.init();
        this.init2();
    },
    mounted () {
    },
    methods: {
        ...mapActions({
            setManageSettingQ: 'hostSetModule/setManageSettingQ', //
            demolitionboothandinstallationconstructionGet: "hostSetModule/demolitionboothandinstallationconstructionGet",
            DemolitionBoothAndInstallationConstructionRecordPost: "exhibitionModuleY/DemolitionBoothAndInstallationConstructionRecordPost",
            demolitionboothandinstallationconstructionrecordGet: "exhibitionModuleY/demolitionboothandinstallationconstructionrecordGet",

        }),
        goDetail () {
            this.$router.push('/exhibition/index/order/detail-order');
        },
          // 获取列表
          async init2 () {
            let res = await this.demolitionboothandinstallationconstructionGet();
            res.map(e => {
                e.number = null
                e.total = null
            })
            this.list = res
            this.init3();
        },
        //获取列表下的数量金额
        async init3 () {
            let res = await this.demolitionboothandinstallationconstructionrecordGet(this.queryId);
            if(!res||res.length==0){
                this.list = []
                // this.$message.warning("用户获取信息失败");
                return
            }
            this.list.map((i,index) => {
                res.map(j => {
                    if (i.id == j.itemId) {
                        i.number = j.number
                        i.total = j.amount
                    }
                })
               
            })
            this.list.map((i,index) => {
                if(i.number==null){
                   this.list.splice(index,1)
                }
               
            })
            console.log(this.list);
            
        },
        getSummaries (param) {
            //此处打印param可以看到有两项，一项是columns，一项是data，最后一列可以通过columns.length获取到。
            const { columns, data } = param
            const len = columns.length
            const sums = []
            columns.forEach((column, index) => {
                //如果是第一列，则最后一行展示为“总计”两个字
                if (index === 0) {
                    sums[index] = '总计'
                    //如果是最后一列，索引为列数-1，则显示计算总和
                } else if (index === len - 1) {
                    const values = data.map(item => Number(item[column.property]))
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr)
                            if (!isNaN(value)) {
                                return prev + curr
                            } else {
                                return prev
                            }
                        }, 0)
                    } else {
                        sums[index] = 'N/A'
                    }
                    //如果是除了第一列和最后一列的其他列，则显示为空
                } else {
                    sums[index] = ''
                }
            })
            return sums
        }

    }
}
</script>

<style lang="scss" scoped>
.all-order {
    min-width: 1000px;
    padding: 30px;
    min-height: 500px;

    &-content {
        background: #FFF;

        .goods {
            width: 18%;
            padding: 10% 0;
            display: inline-block;
            position: relative;
            margin: 0 3px;

            img {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                max-width: 100%;
                max-height: 100%;
                margin: auto;
            }
        }

        .goods-e {
            position: absolute;
            left: 100%;
            top: 30%;
            font-weight: bold;
        }

        .operation {
            color: #1890ff;
            cursor: pointer;
        }
    }
}

/deep/ .el-descriptions__body .el-descriptions__table {
    margin: 30px;
}
</style>